export enum NotificationActionTypes {
	GET_NOTIFICATIONS_REQUEST = "@@notifications/GET_NOTIFICATIONS_REQUEST",
	GET_NOTIFICATIONS_SUCCESS = "@@notifications/GET_NOTIFICATIONS_SUCCESS",
	GET_NOTIFICATIONS_ERROR = "@@notifications/GET_NOTIFICATIONS_ERROR",

	MARK_AS_READ_REQUEST = "@@notifications/MARK_AS_READ_REQUEST",
	MARK_AS_READ_SUCCESS = "@@notifications/MARK_AS_READ_SUCCESS",
	MARK_AS_READ_ERROR = "@@notifications/MARK_AS_READ_ERROR",

	MARK_ALL_AS_READ_REQUEST = "@@notifications/MARK_ALL_AS_READ_REQUEST",
	MARK_ALL_AS_READ_SUCCESS = "@@notifications/MARK_ALL_AS_READ_SUCCESS",
	MARK_ALL_AS_READ_ERROR = "@@notifications/MARK_ALL_AS_READ_ERROR",

	SSE_NEW_NOTIFICATION = "@@notifications/SSE_NEW_NOTIFICATION"
}

export interface Notification {
	id: string;
	type: string;
	template_key: string;
	payload: any;
	status: string;
	read_status: string;
	created_at: string;
	sent_at?: string;
	error?: string;
}

export interface Pagination {
	size: number;
	page: number;
	pages: number;
	total: number;
	elements: number;
	last: boolean;
	first: boolean;
	offset: number;
	hasNext: boolean;
	hasPrevious: boolean;
	unreadByType: Record<string, number>;
	totalUnread: number;
}

export interface NotificationState {
	centerLoading: boolean;
	dropdownLoading: boolean;
	isMarkAllLoading: boolean;
	markingIds: string[];

	centerList: Notification[];
	dropdownList: Notification[];
	error?: string;
	pagination: Pagination;
}
